<template>
    <div>
        <b-row class="justify-content-md-center">
            <p  style="font-size: 21px">Items Del pedido</p>
        </b-row>
        <b-row>
            <b-table 
                responsive
                :fields="fields" 
                striped hover  
                :items="items">
                <template v-slot:cell(referencia)="data">
                    <b-row>
                        <b-col class="col-sm-2 d-none d-sm-block">
                            <b-img :src="data.item.imagen" :alt="data.item.nombre_item" style="max-width: 100%; max-height: 100px; object-fit: scale-down;"></b-img>
                        </b-col>
                        <b-col cols="12" md="9">
                            <div>
                                {{ data.item.nombre_item }}
                            </div>
                            <div>
                                <b>Item:</b> {{ data.item.referencia }}
                            </div>
                        </b-col>
                    </b-row>
                </template>
                <template v-slot:cell(valor_real_unit)="data">
                    $ {{numberFormat(data.item.valor_real_unit)}}
                </template>
                <template v-slot:cell(porcentaje_impuesto)="data">
                    {{data.item.porcentaje_impuesto}} %
                </template>
                <template v-slot:cell(subtotal_items)="data">
                    $ {{ numberFormat(data.item.subtotal_items) }}
                </template>
            </b-table>
        </b-row>
    </div>
</template>

<script>
export default {
    name: "ItemsComponent",
    props: {
        items: {
            type: Array
        },
        descuento:{
            type: Boolean
        }
    },
    data(){
        return{
            fields: [
                { key: 'referencia', label: 'Item', sortable: true},
                { key: 'cantidad', label: 'Cantidad', sortable: true},
                { key: 'valor_real_unit', label: 'Vr. Unit', sortable: true},
                { key: 'porcentaje_impuesto', label: 'Impuesto', sortable: true},
                { key: 'subtotal_items', label: 'Subtotal', sortable: true},
            ],
        }
    }
};

</script>
<style scoped>

</style>